<template>
  <div>
    <a-button style="margin-bottom: 8px;width: 120px;" type="primary" @click="handleSave()" :loading="saveLoading" v-acl="'page_mdc_setting_analysis_save'">{{$t('save')}}</a-button>
    <ml-table :columns="columns" :data-source="data" :scroll="{y: scrallHeight}" :loading="loading">
      <template
        slot="wcs"
        slot-scope="text"
      >
        <div>
          {{'S' + text}}
        </div>
      </template>
      <template
        v-for="col in ['wcsName', 'rpsName']"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-select :value="text" :disabled="col === 'wcsName'"
          show-search
          optionFilterProp="children"
          style="width: 100%" @change="e => handleChange(e, record.id, col)">
            <template v-if="col === 'wcsName'">
              <a-select-option :value="item" v-for="(item,index) in wcsNameList" :key="index">
                {{ item }}
              </a-select-option>
            </template>
            <template v-else>
              <a-select-option :value="item.name" v-for="(item,index) in rpsNameList" :key="index">
                {{ item.name }}
              </a-select-option>
            </template>
          </a-select>
        </div>
      </template>
    </ml-table>

  </div>
</template>
<script>
import { WorkStationWorkingConditionStatusServiceProxy,WorkStationWcsSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const wkwcssp = new WorkStationWorkingConditionStatusServiceProxy()
const wswssp = new WorkStationWcsSettingServiceProxy()
export default {
  data() {
    return {
      data: [],
      columns:[
        {
          title: this.$t('page_mdc_setting_index'),
          dataIndex: 'wcs',
          width: '20%',
          ellipsis: true,
          scopedSlots: { customRender: 'wcs' }
        },
        {
          title: this.$t('page_mdc_setting_state'),
          dataIndex: 'wcsName',
          width: '40%',
          ellipsis: true,
          scopedSlots: { customRender: 'wcsName' },
        },
        {
          title: this.$t('page_mdc_setting_belonging'),
          dataIndex: 'rpsName',
          width: '40%',
          ellipsis: true,
          scopedSlots: { customRender: 'rpsName' },
        }
      ],
      editingKey: '',
      scrallHeight: 750,
      loading: false,
      wcsNameList: [],
      rpsNameList: [
        {value: 1, name: '加工时间'},
        {value: 2, name: '加工间歇'},
        {value: 3, name: '工程调试'},
        {value: 4, name: '停机时间'},
        {value: 5, name: '报警时间'},
        {value: 6, name: '非班次时间'},
      ]
    };
  },
  created() {
    const scrall = document.querySelector('#app')
    this.scrallHeight = scrall.clientHeight - 175
    this.getList()
  },
  methods: {
    getList(){
      this.loading= true
      this.wcsNameList = []
      this.data = []
      wswssp.getWorkStationWcsSettingList().then(res =>{
        res.forEach(item =>{
          this.wcsNameList.push(item.name)
        })
        this.wcsNameList = Array.from(new Set(this.wcsNameList))
      })
      wkwcssp.getWorkConditionStatus().then(res =>{
        this.data = res
        this.loading = false
      })
    },
    handleSave(){
      this.saveLoading = true
      wkwcssp.editorConditionStatusSetting({'list': this.data}).then(() =>{
        this.saveLoading = false
        this.$message.success(this.$t('save_success'))
        this.$emit('change',false)
        this.getList()
      }).catch(() => {
        this.saveLoading = false
      })
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        if(column === 'rpsName'){
          target['rps'] = this.rpsNameList.find(item => item.name === value).value
        }
        this.data = newData;
        this.$emit('change',true)
      }
    },
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>
